import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import CustomerChat from './CustomerChat';
import $ from 'jquery';
import CampaignTabSettings from './CampaignTabSettings';


class WhatsAppSettings extends Component {
  constructor() {
    super();
    this.state = {
      projectId: null,
      hideBotStore: false,
      hideButton: false
    }
  }

  fetchRoles = () => {

    var localController = this;
    localController.state.hideButton = false;
    localController.setState(localController.state)
    $.ajax({
      url: "/api/project-membership",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem('currentProjectId'),
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

      success: function (res) {
        if (res.success === true) {
          var myUserId = JSON.parse(localStorage.getItem("user_details"))["userId"];
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i].userId == myUserId && res.result[i].role == "PROJECT_SUPPORT_USER") {
              localController.state.hideButton = true;
              localController.setState(localController.state);

            }

          }

        }

      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/";
        }
      }

    });
  }

  componentDidMount() {

    var authToken = localStorage.getItem("access_token");
    if (!authToken) {
      window.location.href = "/sales-desk/login";
    }

    setTimeout(() => {
      this.fetchRoles();
    }, 300);

    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/sales-desk/projectmgmt";
      var path1 = window.origin + "/sales-desk/projectmgmt/";
      if (currentPath === path || currentPath === path1) {
        $("#custome-chat").addClass('active');
      } else if (currentPath.includes("/projectmgmt/manage-template") ||
        currentPath.includes("/projectmgmt/manage-template/")) {
        $("#manage-template").addClass('active');
      } else if (currentPath.includes("/projectmgmt/out-reach-campaign") ||
        currentPath.includes("/projectmgmt/out-reach-campaign/")) {
        $("#out-reach-campaign").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#custome-chat,#manage-template,#out-reach-campaign")
        .on("click", function () {
          $("#custome-chat,#manage-template,#out-reach-campaign")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
      $("#outreach-campaign").on("click", function () {
        $("#create-new-campaign,#manage-campaign")
          .removeClass('active');
        $("#create-new-campaign").addClass('active');
      })



    })();


    if (localStorage.getItem("currentProjectId") == null) {
      this.getDetails();

    }
  }
  getDetails() {
    $.ajax({
      url: "/api/project",
      async: false,
      method: 'GET',
      data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("currentProjectId", res.result[0].id);

        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      }
    });
  }



  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">

                <div className="col-sm-5">
                  <h1 className="m-0 page-title" >Customer Desk</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">

              <ul className="nav nav-tabs border-bottom navCluster">

                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="custome-chat" style={{ marginRight: '15px' }}>
                    Customer chat
                  </li></Link>

               
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/out-reach-campaign" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="out-reach-campaign" style={{ marginRight: '15px' }}>
                    Outreach Campaign
                  </li></Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/out-reach-campaign" component={CampaignTabSettings}></Route>
          <Route path="/projectmgmt" component={CustomerChat}></Route>
        </Switch>
      </div>

    );
  }
}
export default WhatsAppSettings;




// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/WhatsAppSettings.js